<template>
    <v-form>
        <v-row>
            <v-col cols="12">
                <api-token-form @token-changed="onTokenChanged"></api-token-form>
            </v-col>
        </v-row>
        <div v-if="hasTokenApi">
            <v-row  v-for="(webhook, i) in webhooks" :key="webhook.service">
                <v-col cols="12">
                    <v-text-field
                        label="URL"
                        v-model="webhooks[i].url"
                    >
                        <template v-slot:prepend>
                            <v-subheader>{{webhooks[i].title}}</v-subheader>
                        </template>
                        <template v-slot:append-outer>
                            <v-btn color="primary"
                                   class="mx-2"
                                   fab
                                   dark
                                   small
                                   @click="onSave(webhooks[i])"
                            >
                                <v-icon dark>
                                    mdi-content-save
                                </v-icon>
                            </v-btn>
                            <v-btn color="error"
                                   class="mx-2"
                                   fab
                                   dark
                                   small
                                   @click="onRemove(webhooks[i])"
                            >
                                <v-icon dark>
                                    mdi-delete
                                </v-icon>
                            </v-btn>
                        </template>
                    </v-text-field>
                </v-col>
            </v-row>
        </div>
    </v-form>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import * as debtsApi from '@/api/debtsApi';
import ApiTokenForm from "./ApiTokenForm.vue";
export default {
    name: "DebtWebHooksForm",
    components: {ApiTokenForm},
    props:{
    },
    mounted(){

    },
    data(){
        return {
            isFetch: false,
            webhooks: [],
            hasTokenApi: false
        }
    },
    watch: {
        hasTokenApi(val){
            if(true === val){
                this.load();
            }
        }
    },
    methods: {
        ...mapActions('notifications', ['SHOW_SUCCESS', 'SHOW_ERROR', 'SHOW_RESPONSE_ERROR']),
        onTokenChanged(token){
            this.hasTokenApi = token !== "";
        },

        validateUrl(url){
            const expression = /[-a-zA-Z0-9@:%._\\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\\+.~#?&//=]*)/gi;
            const regex = new RegExp(expression);
            if (url.match(regex)) {
                return true;
            }
            this.SHOW_ERROR('Введите валидный url')
            return false;
        },
        async onSave(webhook){
            if(!this.validateUrl(webhook.url)){
                return Promise.reject();
            }
            try {
                this.isFetch = true;
                let response = await debtsApi.setWebHook(webhook.service, webhook.url);
                this.setWebhooks(response.data.response.webhooks);
                this.SHOW_SUCCESS(response.data.message);
            }catch (e) {
                this.SHOW_RESPONSE_ERROR({errorResponse: e, defaultError: 'Произошла ошибка. Повторите попытку'})
                console.log(e);
            }finally {
                this.isFetch = false;
            }
        },
        async onRemove(webhook){
            try {
                this.isFetch = true;
                let response = await debtsApi.deleteWebHook(webhook.service);
                this.setWebhooks(response.data.response.webhooks);
                this.SHOW_SUCCESS(response.data.message);
            }catch (e) {
                this.SHOW_RESPONSE_ERROR({errorResponse: e, defaultError: 'Произошла ошибка. Повторите попытку'})
                console.log(e);
            }finally {
                this.isFetch = false;
            }
        },
        async load(){
            try {
                this.isFetch = true;
                let response = await debtsApi.all()
                this.setWebhooks(response.data.response.webhooks);
            }catch (e) {
                this.SHOW_RESPONSE_ERROR({errorResponse: e, defaultError: 'Произошла ошибка. Повторите попытку'})
                console.log(e);
            }finally {
                this.isFetch = false;
            }
        },
        setWebhooks(data){
            const bases = [{service: "IMPORT", title: "Вебхук Импорт", url: ''}, {service: "EXPORT", title: "Вебхук Экспорт", url: ''}];
            this.webhooks.splice(0, this.webhooks.length, ...[...data, ...bases.filter((el) => !data.map((el) => el.service).includes(el.service))])
        }
    },
    computed: {
        ...mapGetters( 'user', ['USER_ID']),
    }
}
</script>

<style scoped>

</style>